/*
 * Copyright (c) 2025, Ramble Ventures
 */
export const Spinner = function (props) {
    return (
        <span className="publishpress-future-spinner"><div></div><div></div><div></div><div></div></span>
    );
}
